import { type FC } from "react";

import { getConfig } from "config/config";

import styles from "./AppVersion.module.scss";

export const AppVersion: FC = () => {
  return <div className={styles.version}>{getConfig().appVersion}</div>;
};
